"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f2358 = void 0;
exports.f2358 = {
    "शेर्वी तम्ङे": [
        8639
    ],
    "शेर्वी": [
        8639
    ]
};
